export type OrigenDeuda = 'compra_credito' | 'prestamo';
export type Deposito = 'si' | 'no';

export const MENSAJE_ORIGEN_FALTANTE = 'Adjunta el documento que origina la deuda: contrato, pagaré, factura a crédito o comprobante del depósito.';

interface ValidarOrigenDeudaInput {
  readonly comprobanteExigible: boolean;
  readonly origenDeuda: OrigenDeuda | '';
  readonly depositado: Deposito | '';
  readonly montoRecibido: number;
  readonly montoTotal: number;
}

/** Lo que el formulario de alta debe haber respondido sobre el origen de la deuda. */
export function validarOrigenDeuda(input: ValidarOrigenDeudaInput): string | null {
  const { comprobanteExigible, origenDeuda, depositado, montoRecibido, montoTotal } = input;
  if (comprobanteExigible && origenDeuda === '') return 'Indica qué originó la deuda.';
  if (origenDeuda === 'prestamo' && depositado === '') return 'Indica si el dinero se depositó en la cuenta.';
  if (depositado === 'si' && (montoRecibido <= 0 || montoRecibido > montoTotal)) {
    return 'Indica cuánto dinero llegó a la cuenta.';
  }
  return null;
}

/** Solo un préstamo depositado declara cuánto dinero llegó a la cuenta; en los demás casos no hay entrada por financiamiento. */
export function montoRecibidoDelPrestamo(origenDeuda: OrigenDeuda | '', depositado: Deposito | '', montoRecibido: number): number | null {
  return origenDeuda === 'prestamo' && depositado === 'si' ? montoRecibido : null;
}
